import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";

const Search = (props) => {
  const {
    data,
    htmlFor,
    label,
    name,
    stateData,
    setStateData,
    placeholder,
    setId,
  } = props;

  const [options, setOptions] = useState([]);

  const pushObj = useCallback(() => {
    setOptions([]);
    data.forEach((item) => {
      setOptions((current) => [
        ...current,
        {
          id: item?._id,
          value: item?.name,
          label: item?.name,
        },
      ]);
    });
  }, [data]);

  useEffect(() => {
    if (data) {
      pushObj();
    }
  }, [data]);

  const styles = {
    control: (styles, { isFocused }) => {
      return {
        ...styles,
        borderRadius: "4px",
        textAlign: "left",
        border: "1px solid var(--border_primary)",
        border: isFocused
          ? "1px solid var(--border_primary)"
          : "1px solid var(--border_primary)",
        boxShadow: "none",
        cursor: "pointer",
        height: "32px",
        width: "200px",
        minHeight: "auto",
      };
    },
    indicatorSeparator: () => {
      return {
        display: "none",
      };
    },
    placeholder: (styles) => {
      return {
        ...styles,
        fontSize: "14px",
      };
    },
    singleValue: (styles) => {
      return {
        ...styles,
        fontSize: "14px",
        textTransform: "capitalize",
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        borderRadius: "4px",
        margin: 0,
        backgroundColor: "var(--border_secondary)",
      };
    },
    menuList: (styles) => {
      return {
        ...styles,
        overflow: "auto",
        height: "fit-content",
        maxHeight: "150px",
        "::-webkit-scrollbar": {
          display: "none",
        },
      };
    },
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        color: "#000",
        backgroundColor: isSelected && "#fff",
        borderBottom: "1px solid var(--border_primary)",
        textAlign: "left",
        margin: 0,
        cursor: "pointer",
        fontSize: "14px",
        padding: "10px 11px",
        textTransform: "capitalize",
        ":last-child": {
          borderBottom: "none",
        },
      };
    },
  };

  return (
    <>
      <div className="selectDropdown" style={{ height: 32 }}>
        {label && (
          <label htmlFor={htmlFor} className="font12x500 form-label mb-1">
            {label}
          </label>
        )}
        <Select
          options={options}
          placeholder={placeholder}
          styles={styles}
          name={name}
          value={options.filter((option) => {
            return option.value === stateData;
          })}
          onChange={(e) => {
            setStateData(e.value, e.id);
          }}
        />
      </div>
    </>
  );
};

export default Search;
